export default function(baseUrl) {
  return {
    SelectnDLFeature: `${baseUrl}/GPTools/DLFeatureList/GPServer/SelectnDLFeature`,
    ProjectGroundProfile: `${baseUrl}/GPTools/ProjectGroundProfile/GPServer/ProjectGroundProfile`,
    ProjectGIStation: `${baseUrl}/GPTools/ProjectGIStation/GPServer/ProjectGIStation`,
    countFeatureType: `${baseUrl}/GPTools/countFeatureType/GPServer/countFeatureType`,
    PointElevation: `${baseUrl}/GPTools/SpotHeight/GPServer/PointElevation`,
    SelectAndDownload: `${baseUrl}/GPTools/SelectAndDownload3/GPServer/SelectAndDownload`,
    ClipLiDAR: `${baseUrl}/GPTools/ClipLiDAR/GPServer/ClipLiDAR`,
    AGS: `${baseUrl}/GPTools/ProjectAGS/GPServer/GeologicalProfile`,
  };
}
